import FaqPage from "~/components/Faq/FaqPage";

const ForBuyers = () => {
  return (
    <FaqPage
      selected={"for-buyers"}
      description={
        "A list of Frequently Asked Questions (FAQs) from our buyers to support their use of RealEstateAgents.com."
      }
    />
  );
};

export default ForBuyers;
